import { useAuthContext } from "@features/auth/contexts/AuthContext";
import { useQuery } from "@tanstack/react-query";
import { examsListQueryOptions } from "api/exams-query";

const useExamsListQuery = () => {
	const { isSignedIn, userLogicalId } = useAuthContext();
	return useQuery({
		...examsListQueryOptions(userLogicalId),
		enabled: Boolean(isSignedIn && userLogicalId),
	});
};

export default useExamsListQuery;
